import { getConfig } from '~/utils/helpers'

export default function ({ context }) {
  const devUrl = 'https://staging18.staging.gb.ru/api/v2'
  const prodUrl = 'https://gb.ru/api/v2'
  const baseUrl = context.$config.isProd ? prodUrl : devUrl

  return {
    async getFeedbacksData(params) {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/reviews`,
          {
            ...getConfig(context.$jwt()),
            params
          }
        )

        return data
      } catch (e) {
        console.warn(e)

        return {
          feedbacks: [],
          pagination: { count: 0, offset: 0 }
        }
      }
    },

    async getFeedbacksAverageScore(params) {
      try {
        const { data } =  await context.$axios.get(
          `${baseUrl}/reviews/average_scores`,
          {
            ...getConfig(context.$jwt()),
            params
          }
        )

        return data
      } catch (e) {
        console.warn(e)

        return {}
      }
    },

    async getFeedbacksExternalScore() {
      try {
        const { data } = await context.$axios.get(
          `${baseUrl}/reviews/external_scores`,
          getConfig(context.$jwt())
        )

        return data
      } catch (e) {
        console.warn(e)

        return {}
      }
    }
  }
}
